import {
  createWindowDimensionsContext,
  WindowDimensionsContext,
} from './WindowDimensionsContext.js';
import { useWindowSize } from '@contra/react-hooks/useWindowSize';
import { type ReactNode, useMemo } from 'react';

export const WindowDimensionsProvider = ({
  children,
}: {
  readonly children: ReactNode;
}) => {
  const { height, width } = useWindowSize();

  const context = useMemo(() => {
    return createWindowDimensionsContext({
      height,
      width,
    });
  }, [height, width]);

  return (
    <WindowDimensionsContext.Provider value={context}>
      {children}
    </WindowDimensionsContext.Provider>
  );
};
